module.exports = __webpack_public_path__ + "static/img/game-logo-qtech.d1569b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-qtech.png
// module id = GRGl
// module chunks = 0 1 2 3 4 5 6